// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_3Ay8Q","wrapperMode":"style_wrapperMode_2UkxK","wrapperOpacity":"style_wrapperOpacity_1mykG","text":"style_text_23wtO"};